import all from '../all'
import avisoItEcommerce from './aviso-it-ecommerce'
import newHomePage from './new-homepage'
import newEcommerce from './new-ecommerce'

const bmar = {
  ...all,
  avisoItEcommerce,
  newHomePage,
  newEcommerce,
}

export default bmar
